// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"1be93aa5","262":"21eeb3b8"}[chunkId] + ".chunk.js";
};